import React, { useState } from 'react'
import { Avatar } from '../../../types/modules/admin/avatar.type'
import { Edit } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import CustomModal from '../../ui/CustomModal'
import UpdateAvatarForm from './UpdateAvatarForm'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    avatar:Avatar
}

function AvatarItem({avatar}:Props) {
    const [isOpen, setIsOpen] = useState(false);
    const {t} = useTranslation();

  return (
    <>
    <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(avatar.id)}
    </td>
    <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        <img src={avatar.url} alt={avatar.id.toString()} className='w-20 h-20 object-contain rounded-full border border-primaryButton'/>
    </td>
    <PermissionGate permissions={[PermissionsKey.UpdateAvatar]}>
         <td className="p-3 min-w-[200px] text-Black font-normal">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
        </td>
    </PermissionGate>

     <CustomModal
        isOpen={isOpen}
        onClose={() => {
            setIsOpen(false);
        }}
        title={t('update_information')}
        >
        <UpdateAvatarForm
        id={avatar.id}
        imageUrl={avatar.url}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default AvatarItem